var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRewardBonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-reward-bonus_svg__a",
    x1: "77.158%",
    x2: "4.024%",
    y1: "-29.429%",
    y2: "178.738%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EAD3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B244D2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ic-reward-bonus_svg__c",
    width: "124.3%",
    height: "120.5%",
    x: "-12.2%",
    y: "-10.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    "in": "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    values: "0 0 0 0 0.721957237 0 0 0 0 0.404874034 0 0 0 0 0.814439838 0 0 0 0.550016984 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic-reward-bonus_svg__b",
    d: "M15.405.406L27.496 7.55c.529.312.853.88.853 1.495v14.359c0 .614-.324 1.182-.853 1.495l-12.09 7.144a1.737 1.737 0 01-1.767 0l-12.09-7.144a1.735 1.735 0 01-.854-1.495V9.045c0-.614.324-1.183.853-1.495L13.638.406a1.737 1.737 0 011.767 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3.281 1.094)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#ic-reward-bonus_svg__a)",
    xlinkHref: "#ic-reward-bonus_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ic-reward-bonus_svg__c)",
    xlinkHref: "#ic-reward-bonus_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#3B385E",
    strokeWidth: 1.728,
    xlinkHref: "#ic-reward-bonus_svg__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B385E",
    fillRule: "nonzero",
    d: "M18.895 13.696a.315.315 0 00-.228-.087h-1.7a3.34 3.34 0 00-.636-1.4h2.316a.31.31 0 00.228-.087.296.296 0 00.09-.223v-.991a.298.298 0 00-.09-.224.315.315 0 00-.229-.087h-8.268a.314.314 0 00-.229.087.298.298 0 00-.09.224V12.2c0 .084.032.157.095.218a.307.307 0 00.224.093h1.44c1.399 0 2.287.366 2.664 1.098h-4.104a.314.314 0 00-.229.087.3.3 0 00-.09.224v.99c0 .092.03.166.09.224.06.059.136.088.229.088h4.244c-.146.531-.486.936-1.02 1.214-.533.279-1.237.418-2.111.418h-1.113a.307.307 0 00-.224.093.293.293 0 00-.094.218V18.4c0 .085.03.156.089.214 1.272 1.322 2.922 3.171 4.95 5.549.06.078.142.116.248.116h1.938c.14 0 .235-.058.288-.175.066-.116.053-.226-.04-.33-1.934-2.32-3.455-4.055-4.561-5.208 1.126-.13 2.04-.486 2.743-1.07.702-.582 1.13-1.34 1.282-2.273h1.67c.092 0 .168-.03.228-.088a.296.296 0 00.09-.223v-.991c0-.09-.03-.165-.09-.224z"
  }))));
}
export default SvgIcRewardBonus;